import { useLang } from "@/context/LanguageContext";

export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  const opts = ["pl", "en", "cs", "de"];
  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center rounded-full border border-slate-300 bg-white p-0.5 ${className}`}
    >
      {opts.map((o) => (
        <button
          key={o}
          data-testid={`lang-${o}`}
          onClick={() => setLang(o)}
          aria-pressed={lang === o}
          className={`font-mono-x text-[10px] uppercase tracking-widest px-2.5 py-1.5 rounded-full transition-colors duration-300 ${
            lang === o ? "bg-[hsl(var(--accent))] text-white" : "text-slate-500 hover:text-slate-900"
          }`}
        >
          {o}
        </button>
      ))}
    </div>
  );
}
